jQuery(function () {
  var selector = '[data-behaviour~="select-only-one"]';

  // BEHAVIOUR

  jQuery(document).on("change", selector, uncheckOthers);

  // EVENT HANDLER

  function uncheckOthers() {
    var element = jQuery(this);

    if (!element.is(":checked")) {
      return false;
    }

    var scope = element.data("scope");
    var target = element.data("target");

    element
      .closest(scope)
      .find("[data-target=" + target + "]")
      .not(element)
      .prop("checked", false);
  }
});
